var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseListV2',{attrs:{"model-class":_vm.DataApplication,"collection-filter":_vm.filter}})}
var staticRenderFns = []

export { render, staticRenderFns }